import { useTranslation } from 'react-i18next'
import {
  Dialog,
  DialogContent,
  DialogTitle,
} from '@quebon/ui/components/dialog'
import completionPopper from '@/assets/learner/completion-popper.svg'
import { Button } from '@/components/learner/ui/Button'

interface ReviewCompletionDialogProps {
  open: boolean
  onConfirm: () => void
}

export function ReviewCompletionDialog({ open, onConfirm }: ReviewCompletionDialogProps) {
  const { t } = useTranslation('learner')

  return (
    <Dialog
      open={open}
      onOpenChange={(nextOpen) => {
        if (!nextOpen) onConfirm()
      }}
    >
      <DialogContent
        showCloseButton={false}
        overlayClassName="bg-black/20 backdrop-blur-none"
        className="flex max-w-[360px] flex-col items-center gap-6 rounded-3xl border-0 bg-white px-6 pb-6 pt-8 text-center shadow-[0_8px_8px_rgba(0,0,0,0.10)] ring-0 sm:max-w-[360px]"
      >
        <div className="flex size-20 items-center justify-center rounded-full bg-lc-key-50">
          <img src={completionPopper} alt="" className="size-10" />
        </div>
        <DialogTitle className="w-full text-lc-v3-h4 font-bold leading-[1.45] text-lc-text-primary">
          {t('specialLecture.review.completionTitle')}
        </DialogTitle>
        <Button size="L" className="min-w-[120px]" onClick={onConfirm}>
          {t('specialLecture.review.confirm')}
        </Button>
      </DialogContent>
    </Dialog>
  )
}
